// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type UserQueryVariables = Exact<{
  site: string;
}>;


export type UserQuery = { features: { id: string, walletCurrency: string | undefined } | undefined, userManagement: { id: string, user: { __typename: 'UserManagementUser', id: string, email: string | undefined, username: string | undefined, signupTime: number | undefined, authMethods: Array<string | undefined> | undefined } | undefined, profile: { __typename: 'UserManagementProfile', _id: string | undefined, id: string, firstName: string | undefined, lastName: string | undefined, maidenName: string | undefined, email: string | undefined, country: string | undefined, phone: string | undefined, affiliateID: string | undefined, city: string | undefined, zip: string | undefined, house: string | undefined, address: string | undefined, state: string | undefined, dateOfBirth: number | undefined, language: string | undefined, hasOtp: boolean | undefined, hasSMS2FA: boolean | undefined, emailVerified: boolean | undefined, passwordChangeDate: number | undefined, contactsRequestedTime: number | undefined, lineId: string | undefined, conversionCurrency: string | undefined, telegramId: string | undefined, settings: { siteTheme: string | undefined, wallets: string | undefined, loyaltyLandingDisabled: string | undefined, loyaltyLevelNotfDisabled: string | undefined, verifyEmailClosed: string | undefined, rtpLiveOnboardingClosed: string | undefined, preferredInGameCurrency: string | undefined, inGameCurrencyOnboardingClosed: string | undefined, hasVisitedBCIO: string | undefined } | undefined } | undefined, countryInfo: { __typename: 'UserManagementCountryInfo', id: string, countryCode: string | undefined, blocked: boolean | undefined } | undefined } | undefined };

export type UserFragment = { __typename: 'UserManagementUser', id: string, email: string | undefined, username: string | undefined, signupTime: number | undefined, authMethods: Array<string | undefined> | undefined };

export type ProfileFragment = { __typename: 'UserManagementProfile', _id: string | undefined, id: string, firstName: string | undefined, lastName: string | undefined, maidenName: string | undefined, email: string | undefined, country: string | undefined, phone: string | undefined, affiliateID: string | undefined, city: string | undefined, zip: string | undefined, house: string | undefined, address: string | undefined, state: string | undefined, dateOfBirth: number | undefined, language: string | undefined, hasOtp: boolean | undefined, hasSMS2FA: boolean | undefined, emailVerified: boolean | undefined, passwordChangeDate: number | undefined, contactsRequestedTime: number | undefined, lineId: string | undefined, conversionCurrency: string | undefined, telegramId: string | undefined, settings: { siteTheme: string | undefined, wallets: string | undefined, loyaltyLandingDisabled: string | undefined, loyaltyLevelNotfDisabled: string | undefined, verifyEmailClosed: string | undefined, rtpLiveOnboardingClosed: string | undefined, preferredInGameCurrency: string | undefined, inGameCurrencyOnboardingClosed: string | undefined, hasVisitedBCIO: string | undefined } | undefined };

export type CountryInfoFragment = { __typename: 'UserManagementCountryInfo', id: string, countryCode: string | undefined, blocked: boolean | undefined };

export const UserFragmentDoc = gql`
    fragment UserFragment on UserManagementUser {
  __typename
  id
  email
  username
  signupTime
  authMethods
}
    `;
export const ProfileFragmentDoc = gql`
    fragment ProfileFragment on UserManagementProfile {
  __typename
  _id
  id
  firstName
  lastName
  maidenName
  email
  country
  phone
  affiliateID
  city
  zip
  house
  address
  state
  dateOfBirth
  language
  hasOtp
  affiliateID
  hasSMS2FA
  emailVerified
  passwordChangeDate
  contactsRequestedTime
  lineId
  conversionCurrency
  telegramId
  settings {
    siteTheme: setting(name: siteTheme)
    wallets: setting(name: wallets)
    loyaltyLandingDisabled: setting(name: loyaltyLandingDisabled)
    loyaltyLevelNotfDisabled: setting(name: loyaltyLevelNotfDisabled)
    verifyEmailClosed: setting(name: verifyEmailClosed)
    rtpLiveOnboardingClosed: setting(name: rtpLiveOnboardingClosed)
    preferredInGameCurrency: setting(name: preferredInGameCurrency)
    inGameCurrencyOnboardingClosed: setting(name: inGameCurrencyOnboardingClosed)
    hasVisitedBCIO: setting(name: hasVisitedBCIO)
  }
}
    `;
export const CountryInfoFragmentDoc = gql`
    fragment CountryInfoFragment on UserManagementCountryInfo {
  __typename
  id
  countryCode
  blocked
}
    `;
export const UserQueryDocument = gql`
    query UserQuery($site: String!) {
  features {
    id
    walletCurrency: myGroupTag(name: "DepositCurrency")
  }
  userManagement {
    id
    user: currentUser {
      ...UserFragment
    }
    profile: currentProfile {
      ...ProfileFragment
    }
    countryInfo: currentCountryInfo(site: $site) {
      ...CountryInfoFragment
    }
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${CountryInfoFragmentDoc}`;